import { render, staticRenderFns } from "./PrimaryOrgSettingsModal.vue?vue&type=template&id=d21502c6&scoped=true"
import script from "./PrimaryOrgSettingsModal.vue?vue&type=script&lang=js"
export * from "./PrimaryOrgSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./PrimaryOrgSettingsModal.vue?vue&type=style&index=0&id=d21502c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21502c6",
  null
  
)

export default component.exports